import React from 'react';

import { Stack, styled, useTheme } from '@liscio/ui';

const Wrapper = styled(Stack)(() => ({
  paddingTop: '24px',
  paddingBottom: '24px',
  img: {
    width: '33%',
    maxWidth: '265px',
    objectFit: 'contain',
  },
}));

export const Logo = () => {
  const theme = useTheme();
  return (
    <Wrapper justifyContent="center" alignItems="center">
      <img src={theme?.assets?.logoSplash} alt="logo" />
    </Wrapper>
  );
};

export default Logo;
